module.exports = __webpack_public_path__ + "static/media/form-preview-icon.273e3f02.svg";